import { Layout } from "antd";
import SideBar from "./SideBar";

const SidebarComponent = ({ collapsed, onNavigate }) => {
  return (
    <Layout.Sider
      className="z-10 bg-white overflow-y-auto overflow-x-hidden side-bar w-[240px]"
      style={{ height: "calc(108vh - 102px)" }}
      collapsible={false}
      collapsed={collapsed}
      collapsedWidth={0}
    >
      <SideBar onNavigate={onNavigate} />
    </Layout.Sider>
  );
};

export default SidebarComponent;
